var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard/icon_+") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_\\uC0C1\\uD488\\uB4F1\\uB85D_\\uC635\\uC158\\uC124\\uC815",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_\\uC0C1\\uD488\\uB4F1\\uB85D_\\uC635\\uC158-\\uC124\\uC815\\uC2DC",
    transform: "translate(-1092.000000, -1937.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC635\\uC158_\\uC635\\uC158\\uC785\\uB825=2\\uAC1C-\\uC120\\uD0DD-\\uC2DC",
    transform: "translate(261.000000, 1815.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "con",
    transform: "translate(50.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC635\\uC158\\uD56D\\uBAA92",
    transform: "translate(200.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn_\\uCD94\\uAC00",
    transform: "translate(570.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.04248366,0.45751634 C7.49121502,0.45751634 7.85498366,0.821284981 7.85498366,1.27001634 L7.85448366,6.14451634 L12.7299837,6.14501634 C13.178715,6.14501634 13.5424837,6.50878498 13.5424837,6.95751634 C13.5424837,7.4062477 13.178715,7.77001634 12.7299837,7.77001634 L7.85448366,7.76951634 L7.85498366,12.6450163 C7.85498366,13.0937477 7.49121502,13.4575163 7.04248366,13.4575163 C6.5937523,13.4575163 6.22998366,13.0937477 6.22998366,12.6450163 L6.22948366,7.76951634 L1.35498366,7.77001634 C0.906252301,7.77001634 0.54248366,7.4062477 0.54248366,6.95751634 C0.54248366,6.50878498 0.906252301,6.14501634 1.35498366,6.14501634 L6.22948366,6.14451634 L6.22998366,1.27001634 C6.22998366,0.821284981 6.5937523,0.45751634 7.04248366,0.45751634 Z",
    id: "dashboard/icon_+"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0174212d5cd19b5ef294ef7e3e479db5.svg";
export { ForwardRef as ReactComponent };